const videoPlayer = () => {
    const config = {
      action: {
        pause: "pause",
        play: "play"
      },
      aria: {
        hidden: "aria-hidden"
      },
      className: {
        hide: "hide"
      },
      dom: {
        pause: "js-video-player-control-pause",
        play: "js-video-player-control-play",
        videoPlayer: "js-video-player",
        videoPlayerWrapper: "js-video-player-wrapper"
      },
      event: {
        click: "click",
        code: {
          enter: "Enter",
          space: "Space"
        },
        keydown: "keydown"
      }
    }
  
    /**
     * Add Event Listeners
     */
    const addEventListeners = () => {
      const $videoPlayerWrappers = document.querySelectorAll(`.${config.dom.videoPlayerWrapper}`)
  
      if (!$videoPlayerWrappers) return
  
      $videoPlayerWrappers.forEach(($videoPlayerWrapper) => {
        const $pause = $videoPlayerWrapper.querySelector(`.${config.dom.pause}`)
        const $play = $videoPlayerWrapper.querySelector(`.${config.dom.play}`)
        const $videoPlayer = $videoPlayerWrapper.querySelector(`.${config.dom.videoPlayer}`)
  
        if (!$pause || !$play || !$videoPlayer) return
  
        $pause.addEventListener(config.event.click, (event) => {
          handleEvent(event, $videoPlayer, $pause, $play, config.action.pause)
        })
  
        $pause.addEventListener(config.event.keydown, (event) => {
          if (event.code === config.event.code.space || event.code === config.event.code.enter) {
            handleEvent(event, $videoPlayer, $pause, $play, config.action.pause)
          }
        })
  
        $play.addEventListener(config.event.click, (event) => {
          handleEvent(event, $videoPlayer, $pause, $play, config.action.play)
        })
  
        $play.addEventListener(config.event.keydown, (event) => {
          if (event.code === config.event.code.space || event.code === config.event.code.enter) {
            handleEvent(event, $videoPlayer, $pause, $play, config.action.play)
          }
        })
      })
    }
  
    /**
     * Handle Event
     * @param {Object} event click || keydown event
     * @param {DOM Element} $videoPlayer <video>
     * @param {DOM Element} $pause <button>
     * @param {DOM Element} $play <button>
     * @param {String} action play || pause
     */
    const handleEvent = (event, $videoPlayer, $pause, $play, action) => {
      if (!event || !$videoPlayer || !action) return
  
      event.preventDefault()
  
      if (action === config.action.play) {
        $videoPlayer.play()
      }
  
      if (action === config.action.pause) {
        $videoPlayer.pause()
      }
  
      if (!$pause || !$play) return
      toggleVideoPausePlayButtons($pause, $play, action)
    }
  
    /**
     * Toggle Video Pause Play Buttons
     * @param {DOM Element} $pause
     * @param {DOM Element} $play
     * @param {String} action pause || play
     */
    const toggleVideoPausePlayButtons = ($pause, $play, action) => {
      if (action === config.action.pause) {
        $pause.classList.add(config.className.hide)
        $play.classList.remove(config.className.hide)
  
        $pause.setAttribute(config.aria.hidden, true)
        $play.setAttribute(config.aria.hidden, false)
  
        $play.focus()
      }
  
      if (action === config.action.play) {
        $pause.classList.remove(config.className.hide)
        $play.classList.add(config.className.hide)
  
        $pause.setAttribute(config.aria.hidden, false)
        $play.setAttribute(config.aria.hidden, true)
  
        $pause.focus()
      }
    }
  
    /**
     * Init
     */
    const init = () => {
      addEventListeners()
    }
  
    init()
  }
  
  videoPlayer()